/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Summer_Focus_Title_ExtendInputs */

const en_dialog_summer_focus_title_extend = /** @type {(inputs: Dialog_Summer_Focus_Title_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Extended by 7 Days`)
};

const ar_dialog_summer_focus_title_extend = /** @type {(inputs: Dialog_Summer_Focus_Title_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم تمديد الفعالية لمدة 7 أيام`)
};

const de_dialog_summer_focus_title_extend = /** @type {(inputs: Dialog_Summer_Focus_Title_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event um 7 Tage verlängert`)
};

const es_dialog_summer_focus_title_extend = /** @type {(inputs: Dialog_Summer_Focus_Title_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento extendido por 7 días`)
};

const fr_dialog_summer_focus_title_extend = /** @type {(inputs: Dialog_Summer_Focus_Title_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement prolongé de 7 jours`)
};

const it_dialog_summer_focus_title_extend = /** @type {(inputs: Dialog_Summer_Focus_Title_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento prolungato di 7 giorni`)
};

const ja_dialog_summer_focus_title_extend = /** @type {(inputs: Dialog_Summer_Focus_Title_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントが7日間延長`)
};

const ko_dialog_summer_focus_title_extend = /** @type {(inputs: Dialog_Summer_Focus_Title_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트 7일 연장`)
};

const pt_br_dialog_summer_focus_title_extend = /** @type {(inputs: Dialog_Summer_Focus_Title_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento prorrogado por 7 dias`)
};

const ru_dialog_summer_focus_title_extend = /** @type {(inputs: Dialog_Summer_Focus_Title_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мероприятие продлено на 7 дней`)
};

const th_dialog_summer_focus_title_extend = /** @type {(inputs: Dialog_Summer_Focus_Title_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขยายเวลากิจกรรมอีก 7 วัน`)
};

const tr_dialog_summer_focus_title_extend = /** @type {(inputs: Dialog_Summer_Focus_Title_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik 7 gün uzatıldı`)
};

const zh_cn_dialog_summer_focus_title_extend = /** @type {(inputs: Dialog_Summer_Focus_Title_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动延长 7 天`)
};

const zh_tw_dialog_summer_focus_title_extend = /** @type {(inputs: Dialog_Summer_Focus_Title_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活動延長 7 天`)
};

/**
* | output |
* | --- |
* | "Event Extended by 7 Days" |
*
* @param {Dialog_Summer_Focus_Title_ExtendInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_summer_focus_title_extend = /** @type {((inputs?: Dialog_Summer_Focus_Title_ExtendInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Summer_Focus_Title_ExtendInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_summer_focus_title_extend(inputs)
	if (locale === "ar") return ar_dialog_summer_focus_title_extend(inputs)
	if (locale === "de") return de_dialog_summer_focus_title_extend(inputs)
	if (locale === "es") return es_dialog_summer_focus_title_extend(inputs)
	if (locale === "fr") return fr_dialog_summer_focus_title_extend(inputs)
	if (locale === "it") return it_dialog_summer_focus_title_extend(inputs)
	if (locale === "ja") return ja_dialog_summer_focus_title_extend(inputs)
	if (locale === "ko") return ko_dialog_summer_focus_title_extend(inputs)
	if (locale === "pt_br") return pt_br_dialog_summer_focus_title_extend(inputs)
	if (locale === "ru") return ru_dialog_summer_focus_title_extend(inputs)
	if (locale === "th") return th_dialog_summer_focus_title_extend(inputs)
	if (locale === "tr") return tr_dialog_summer_focus_title_extend(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_summer_focus_title_extend(inputs)
	return zh_tw_dialog_summer_focus_title_extend(inputs)
});